export default __webpack_public_path__ + "images/snowflake-transparent-exiZv.png";